import React, { Component } from "react";
import FilterBuilder from "./FilterBuilder";

export class AdvancedDriveSettings extends Component {
  state = {
    spiderDoNotSpiderUrl: [],
    spiderOnlySpiderUrl: [],
    spiderDoNotReadUrl: [],
    spiderOnlyReadUrl: [],
    onlyReadContentType: [],
    doNotReadContentType: [],
  };

  componentDidMount() {
    this.settingsUpdated();
    this.parseEditKs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      let onlyReadRegexes = {
        onlyReadUrl: this.props.editKs.properties.spiderProperties
          .spiderOnlyReadUrl,
        onlyReadContentType: this.props.editKs.properties.spiderProperties
          .onlyReadContentType,
      };
      let doNotReadRegexes = {
        doNotReadUrl: this.props.editKs.properties.spiderProperties
          .spiderDoNotReadUrl,
        doNotReadContentType: this.props.editKs.properties.spiderProperties
          .doNotReadContentType,
      };
      let onlySpiderRegexes = {
        onlySpiderUrl: this.props.editKs.properties.spiderProperties
          .spiderOnlySpiderUrl,
      };
      let doNotSpiderRegexes = {
        doNotSpiderUrl: this.props.editKs.properties.spiderProperties
          .spiderDoNotSpiderUrl,
      };
      this.onOnlyReadUpdate(onlyReadRegexes);
      this.onDoNotReadUpdate(doNotReadRegexes);
      this.onOnlySpiderUpdate(onlySpiderRegexes);
      this.onDoNotSpiderUpdate(doNotSpiderRegexes);
    }
  };

  render() {
    return (
      <div>
        <FilterBuilder
          editKs={this.props.editKs}
          isUrls
          sourceType="WEBSITE"
          onOnlyReadUpdate={this.onOnlyReadUpdate}
          onDoNotReadUpdate={this.onDoNotReadUpdate}
          onOnlySpiderUpdate={this.onOnlySpiderUpdate}
          onDoNotSpiderUpdate={this.onDoNotSpiderUpdate}
        />
      </div>
    );
  }

  onOnlyReadUpdate = (regexes) => {
    let { onlyReadUrl, onlyReadContentType, ...unknown } = regexes;

    this.setState({
      spiderOnlyReadUrl: onlyReadUrl,
      onlyReadContentType: onlyReadContentType,
    });

    if (this.props.onOnlyReadUpdate) {
      this.props.onOnlyReadUpdate(unknown);
    }
  };

  onDoNotReadUpdate = (regexes) => {
    let { doNotReadUrl, doNotReadContentType, ...unknown } = regexes;
    this.setState({
      spiderDoNotReadUrl: doNotReadUrl,
      doNotReadContentType,
    });
    if (this.props.onDoNotReadUpdate) {
      this.props.onDoNotReadUpdate(unknown);
    }
  };

  onOnlySpiderUpdate = (regexes) => {
    let { onlySpiderUrl, ...unknown } = regexes;

    this.setState({ spiderOnlySpiderUrl: onlySpiderUrl });
    if (this.props.onOnlySpiderUpdate) {
      this.props.onOnlySpiderUpdate(unknown);
    }
  };

  onDoNotSpiderUpdate = (regexes) => {
    let { doNotSpiderUrl, ...unknown } = regexes;
    this.setState({ spiderDoNotSpiderUrl: doNotSpiderUrl });
    if (this.props.onDoNotSpiderUpdate) {
      this.props.onDoNotSpiderUpdate(unknown);
    }
  };

  settingsUpdated = () => {
    this.props.setSpiderProperties({ ...this.state });
  };
}

export default AdvancedDriveSettings;
